<template>
  <div class="header-warp  wh-flex-center">
    <div class="header-txt wh-flex-center">
      <div class="txt-bg">
        {{ title }}
      </div>
    </div>
    <div class="title-bottom" />
    <wh-weather-box class="weather-box" />
    <wh-date-box class="date-box" />
  </div>
</template>

<script>
import WhWeatherBox from '@/components/WeatherBox/WhWeatherBox'
import WhDateBox from '@/components/WhDateBox/WhDateBox'
export default {
  name: 'Hearder',
  components: { WhDateBox, WhWeatherBox },
  props: {
    title: String,
    default: () => ''
  }
}
</script>

<style lang="less" scoped>
  .header-warp{
    width: 100%;
    height: 155px;
    color: #fff;
    flex-direction: column;
    position: relative;
    .header-txt{
      width: 1386px;
      height: 135px;
      font-size: 43px;
      line-height: 1;
      letter-spacing: 6px;
      background: url("~@/assets/top-title-bg.png") top left no-repeat;
      background-size: 100% 100%;
      position: relative;
      .txt-bg{
        font-family: 微软雅黑;
        background: linear-gradient(to bottom, #2AFCFF, #009192);
        -webkit-background-clip: text;
        color: transparent;
        text-shadow: 0 3px 3px rgba(0, 124, 162, 0.3);
      }
    }
    .title-bottom{
      width: 1250px;
      height: 35px;
      background: url("~@/assets/top-title-bottom.png") top left no-repeat;
      background-size: cover;
      position: relative;
      top: -10px;
    }
  }
  .weather-box{
    position: absolute;
    top: 49px;
    left: 56px;
  }
  .date-box{
    position: absolute;
    top: 49px;
    right: 56px;
  }
</style>
